import CentralApiService from "../centralApiServices"

class PreferenciasUsuarioService extends CentralApiService {

    constructor() {
        super('/api/preferenciasUsuario')
    }

    buscarPreferencias(){
        return this.get(`/buscarPreferencias`)
    }

    salvarPreferencia(chave, valor){
        let params = `?`
        params = `${params}&chave=${chave}`
        return this.post(`/salvarPreferencia${params}`, valor)
    }

}

export default PreferenciasUsuarioService
